var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor_left"}},[_c('editorNoveloutline')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }